// src/pages/ViewBlogsPage.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import { getToken, isTokenValid } from "../utils/auth";
import { useNavigate } from "react-router-dom";

export default function ViewBlogsPage() {
  const [blogs, setBlogs] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  // Fetch blogs
  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/posts`);
      setBlogs(res.data);
    } catch (err) {
      console.error("❌ Error fetching blogs:", err);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (!isTokenValid()) {
      navigate("/adminlogin");
    }
  }, [navigate]);
  
  useEffect(() => {
    fetchBlogs();
  }, []);

  // Edit Blog Save
  // const handleSave = async (e) => {
  //   e.preventDefault();

  //   if (!selectedPost) return;

  //   try {
  //     const formData = new FormData();
  //     formData.append("title", selectedPost.title);
  //     formData.append("content", selectedPost.content);

  //     if (selectedPost.newImage) {
  //       formData.append("image", selectedPost.newImage);
  //     }

  //     await axios.put(`${API_BASE_URL}/posts/${selectedPost._id}`, formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //         Authorization:
  //           "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhZG1pbklkIjoiNjhjODRjZjgyYjRjZTg2MzNiOGM2YzEwIiwiZW1haWwiOiJrYXJhbjFAZXhhbXBsZS5jb20iLCJ1c2VybmFtZSI6ImthcmFuMSIsImlhdCI6MTc1Nzk2MjU5NCwiZXhwIjoxNzU3OTczMzk0fQ.vMXwrnAX2DaSKn2o1RCweSTUoggdC4XuxlwhQARbjxQ",
  //       },
  //     });

  //     alert("✅ Post updated successfully");
  //     setSelectedPost(null);
  //     fetchBlogs();
  //   } catch (err) {
  //     console.error("❌ Error updating post:", err);
  //   }
  // };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!selectedPost) return;

    try {
      const formData = new FormData();
      formData.append("title", selectedPost.title);
      formData.append("content", selectedPost.content);

      if (selectedPost.newImage) {
        formData.append("image", selectedPost.newImage); // field name must match multer upload.single("image")
      }

      await axios.put(`${API_BASE_URL}/posts/${selectedPost._id}`, formData, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });

      alert("✅ Post updated successfully");
      setSelectedPost(null);
      fetchBlogs();
    } catch (err) {
      console.error("❌ Error updating post:", err);
    }
  };

  // Delete Blog
  const handleDelete = async () => {
    try {
      await axios.delete(`${API_BASE_URL}/posts/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });
      alert("🗑️ Blog deleted");
      setDeleteId(null);
      fetchBlogs();
    } catch (err) {
      console.error("❌ Error deleting post:", err);
    }
  };

  return (
    <>
      <div className="container-fluid px-5">
        <h3 className="fw-normal my-4">All Blog Posts</h3>
        <div className="row">
          {blogs.length === 0 ? (
            <p className="text-white">No blogs available.</p>
          ) : (
            blogs.map((blog) => (
              <div className="col-md-6 col-lg-4 mb-4" key={blog._id}>
                <div className="card h-100 bg-dark text-white border-light shadow-sm">
                  {blog.imageUrl && (
                    <img
                      src={blog.imageUrl}
                      alt={blog.title}
                      className="card-img-top"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                  )}
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title">{blog.title}</h5>
                    <p className="card-text">
                      {blog.content.length > 100
                        ? blog.content.slice(0, 100) + "..."
                        : blog.content}
                    </p>
                    <div className="mt-auto d-flex justify-content-between">
                      <button
                        className="btn btn-outline-light btn-sm"
                        onClick={() => setSelectedPost(blog)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => setDeleteId(blog._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Edit Modal */}
        {selectedPost && (
          <div
            className="modal show fade"
            style={{ display: "block" }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content bg-dark text-white shadow-lg border-0">
                <form onSubmit={handleSave}>
                  <div className="modal-header border-bottom border-dark">
                    <h5 className="modal-title">Edit Blog</h5>
                    <button
                      type="button"
                      className="btn-close"
                      style={{ filter: "invert(0.5)" }} // 👈 makes close icon grey
                      onClick={() => setSelectedPost(null)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Title</label>
                      <input
                        type="text"
                        className="form-control bg-transparent text-white border-secondary"
                        value={selectedPost.title}
                        onChange={(e) =>
                          setSelectedPost({
                            ...selectedPost,
                            title: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Content</label>
                      <textarea
                        className="form-control bg-transparent text-white border-secondary"
                        rows="4"
                        value={selectedPost.content}
                        onChange={(e) =>
                          setSelectedPost({
                            ...selectedPost,
                            content: e.target.value,
                          })
                        }
                      />
                    </div>

                    {/* Show current image */}
                    {selectedPost.imageUrl && (
                      <div className="mb-3">
                        <label className="form-label">Current Image</label>
                        <img
                          src={selectedPost.imageUrl}
                          alt="Current"
                          style={{
                            maxHeight: "150px",
                            display: "block",
                            marginBottom: "10px",
                          }}
                        />
                      </div>
                    )}

                    <div className="mb-3">
                      <label className="form-label">Upload New Image</label>
                      <input
                        type="file"
                        className="form-control bg-transparent text-white border-secondary"
                        onChange={(e) =>
                          setSelectedPost({
                            ...selectedPost,
                            newImage: e.target.files[0],
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="modal-footer border-top border-dark">
                    <button
                      type="button"
                      className="btn btn-outline-light"
                      onClick={() => setSelectedPost(null)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-light text-dark">
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {deleteId && (
          <div
            className="modal show fade"
            style={{ display: "block" }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content text-white bg-dark shadow-lg border border-secondary">
                <div className="modal-header border-0">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setDeleteId(null)}
                  ></button>
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to delete this blog?</p>
                </div>
                <div className="modal-footer border-0">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setDeleteId(null)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
